export default {"src":"/_next/static/media/new_logo.be0c2fdb.svg","height":192,"width":192,"blurWidth":0,"blurHeight":0};